module.exports = __webpack_public_path__ + "static/img/weather16.be0bcf5a.png";